import { useEffect } from "react";
import { X, Mic } from "lucide-react";
import { playNarration, stopNarration } from "../../lib/narration";

// Game 1 style subtitle band: amber "THE SCIENTIST" label over a bold white line.
export const LabNote = ({ note, onClose }) => {
  useEffect(() => {
    if (!note) return undefined;
    let closed = false;
    const finish = () => { if (!closed) { closed = true; onClose(); } };
    const fallback = setTimeout(finish, 45000);
    playNarration(note.part, { onEnd: () => setTimeout(finish, 1500) });
    return () => { closed = true; clearTimeout(fallback); stopNarration(); };
  }, [note, onClose]);

  if (!note) return null;
  return (
    <aside data-testid="lab-note" className="fixed inset-x-0 bottom-0 z-30 border-t border-amber-300/50 bg-[#050807]/95 px-6 py-6 sm:px-12 backdrop-blur-md note-in">
      <div className="mx-auto flex max-w-5xl items-start gap-6">
        <div className="flex-1 text-center">
          <p className="scientist-label flex items-center justify-center gap-2">
            <Mic size={13} className="animate-pulse" /> The Scientist · lab note · {note.pct}%
          </p>
          <p data-testid="lab-note-text" className="scientist-line mt-3 text-lg sm:text-2xl leading-snug">{note.text}</p>
        </div>
        <button data-testid="lab-note-close" onClick={onClose} className="text-slate-500 hover:text-slate-200 transition-colors" title="Dismiss (Enter)"><X size={20} /></button>
      </div>
    </aside>
  );
};
